var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sticky bottom-0 flex gap-2 justify-end p-4 border-t border-brand-gray-8 dark:border-brand-gray-15 bg-brand-background h-[60px]",attrs:{"data-component":"CsModalFooter"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }